// Drawer chi tiết 1 người: ví, đối soát, hạng, điểm danh, nhiệm vụ hôm nay, máy dùng + sổ Xu + thao tác.
import { useCallback, useEffect, useState } from "react";
import { Alert, Button, Descriptions, Drawer, Space, Spin, Tag, message } from "antd";
import xuProgramApi from "../../../api/xuProgramApi";
import XuUserLedgerTable from "./xu-user-ledger-table";
import XuAdjustModal from "./xu-adjust-modal";
import { apiError, fmtNum, fmtVnDate, fmtVnDateTime, MISSION_LABELS, MISSION_STATUS_LABELS, tierColor } from "./xu-format-helpers";
import { userLabel } from "./xu-beta-user-select";

export default function XuUserDrawer({ userId, onClose, onChanged }) {
    const [detail, setDetail] = useState(null);
    const [loading, setLoading] = useState(false);
    const [adjusting, setAdjusting] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);

    const load = useCallback(async () => {
        setLoading(true);
        try {
            const { data } = await xuProgramApi.getUser(userId);
            setDetail(data.data);
        } catch (e) {
            setDetail(null);
            message.error(apiError(e, "Không tải được thông tin người dùng"));
        } finally {
            setLoading(false);
        }
    }, [userId]);
    useEffect(() => {
        if (userId) load();
    }, [userId, load]);

    const refreshAll = () => {
        setRefreshKey((k) => k + 1);
        load();
        onChanged?.();
    };

    const recompute = async () => {
        try {
            await xuProgramApi.recomputeRank(userId);
            message.success("Đã tính lại hạng");
            refreshAll();
        } catch (e) {
            message.error(apiError(e, "Tính lại hạng thất bại"));
        }
    };

    const d = detail;
    return (
        <Drawer open={Boolean(userId)} onClose={onClose} width={860} title={d ? userLabel(d.user) : `Người dùng #${userId}`} destroyOnClose>
            {loading && !d && <Spin className="block mx-auto mt-10" />}
            {d && (
                <Space direction="vertical" size="middle" className="w-full">
                    {!d.audit.ok && (
                        <Alert type="error" showIcon message={`Số dư lệch sổ! Ví ghi ${fmtNum(d.audit.balance)} nhưng tổng sổ là ${fmtNum(d.audit.ledgerSum)}.`} />
                    )}
                    <Descriptions bordered size="small" column={2}>
                        <Descriptions.Item label="Số dư Xu"><b>{fmtNum(d.wallet.balance)}</b></Descriptions.Item>
                        <Descriptions.Item label="Đối soát sổ">{d.audit.ok ? <Tag color="green">Khớp</Tag> : <Tag color="red">LỆCH</Tag>}</Descriptions.Item>
                        <Descriptions.Item label="Đã nhận hôm nay">{fmtNum(d.wallet.todayEarned)}</Descriptions.Item>
                        <Descriptions.Item label="Xu chờ mở khoá">
                            {d.pending.length ? d.pending.map((p) => <div key={p.id}>{fmtNum(p.amount)} Xu · hết hạn {fmtVnDateTime(p.expiresAt)}</div>) : "Không có"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Hạng">
                            <Tag color={tierColor(d.rank.tier)}>{d.rank.name || `Hạng ${d.rank.tier}`}</Tag>
                        </Descriptions.Item>
                        <Descriptions.Item label="Điểm 90 / 97 ngày">{fmtNum(d.rank.points90)} / {fmtNum(d.rank.points97)} đ</Descriptions.Item>
                        <Descriptions.Item label="Cảnh báo hạ hạng">{d.rank.downgradeWarnedAt ? fmtVnDateTime(d.rank.downgradeWarnedAt) : "Không"}</Descriptions.Item>
                        <Descriptions.Item label="Tính hạng lần cuối">{fmtVnDateTime(d.rank.computedAt)}</Descriptions.Item>
                        <Descriptions.Item label="Điểm danh">
                            Chuỗi {d.checkin.streak} ngày · {d.checkin.checkedToday ? "đã điểm danh hôm nay" : "chưa điểm danh hôm nay"}
                            {d.checkin.newUserLocked && <Tag className="ml-1" color="orange">Chưa có đơn duyệt</Tag>}
                        </Descriptions.Item>
                        <Descriptions.Item label="Nhiệm vụ hôm nay">
                            {d.missions.map((m) => (
                                <div key={m.key}>{MISSION_LABELS[m.key] || m.key}: {MISSION_STATUS_LABELS[m.status] || m.status} ({m.progress}/{m.target})</div>
                            ))}
                        </Descriptions.Item>
                        <Descriptions.Item label="Máy dùng 30 ngày" span={2}>
                            {d.installIds.length ? d.installIds.map((i) => (
                                <div key={i.installId}><code>{i.installId}</code> · {i.days} lượt · gần nhất {fmtVnDate(i.lastDate)}</div>
                            )) : "Chưa có"}
                        </Descriptions.Item>
                    </Descriptions>
                    <Space>
                        <Button type="primary" onClick={() => setAdjusting(true)}>Điều chỉnh Xu</Button>
                        <Button onClick={recompute}>Tính lại hạng</Button>
                        <Button onClick={refreshAll}>Làm mới</Button>
                    </Space>
                    <XuUserLedgerTable userId={userId} refreshKey={refreshKey} onChanged={refreshAll} />
                    <XuAdjustModal
                        open={adjusting}
                        userId={userId}
                        balance={d.wallet.balance}
                        onClose={() => setAdjusting(false)}
                        onDone={() => {
                            setAdjusting(false);
                            refreshAll();
                        }}
                    />
                </Space>
            )}
        </Drawer>
    );
}
